// Contacts with no name are shown by whatever identifies them, never as a blank card.
export const contactDisplayName = (contact, t) =>
  contact.name ||
  contact.email ||
  contact.phoneNumber ||
  contact.identifier ||
  t('AUDIENCES.FORM.PREVIEW.UNNAMED', { id: contact.id });
